import CustomApplicationState from "../Data/CustomApplicationState/CustomApplicationState";

export function getPurchasedProductInfoById(state: CustomApplicationState, productId: string) {
    if(state.ADIGlobalData.myPurchaseHistoryStore.myPurchasedProductInfosByLineId)
    return state.ADIGlobalData.myPurchaseHistoryStore.myPurchasedProductInfosByLineId[productId];
}
